import ThumbnailsMultipleSelectable from './ThumbnailsMultipleSelectable'

export default ThumbnailsMultipleSelectable



// WEBPACK FOOTER //
// ./src/components/ThumbnailsMultipleSelectable/index.js